module.exports = __webpack_public_path__ + "static/wpack/extracted/google-classroom32666d8e6b9883a5c911c7c289dde04a.png";